import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import { createNotification } from '../../../../Config/NotificationToast';
import { logOut, encryptUrlData } from "../../../../utils/Helper";
import { instance } from "../../../auth/axiosInstance";
import { deleteAccountPermanently_API, getDeletedReqUsers_API, recoverAccount_API } from '../../../../Config/Api';

export default function* deleteRequestSaga() {
    yield takeEvery('GET_DELETE_REQ_USERS_LIST', getDeletedReqUsers);
    yield takeLatest('RECOVER_ACCOUNT', recoverAccount);
    yield takeLatest('DELETE_ACCOUNT_PERMENENTLY', deleteAccountPermanently);
}

const getDeletedReqUsersApi = async (URL) => {
    try {
        const response = await instance.get(URL);
        return response;
    } catch (errors) {
        console.log("errors", errors);
        if (
            errors.response.data.statusCode === 400) {
            createNotification('error', errors.response.data.message);
            return
        } if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
}

function* getDeletedReqUsers(action) {
    const URL = `${getDeletedReqUsers_API}?page=${action.data.page_no}&limit=${action.data.page_size}${action.data.filter_text? `&search_text=${action.data.filter_text}` : ''}${action.data.orderBy? `&sort_by=${action.data.orderBy}` : ''}${action.data.order? `&sort_order=${action.data.order?.toUpperCase()}` : ''}`
    try {
        const response = yield call(getDeletedReqUsersApi, URL);
        const userListRes = response;

        if (userListRes.statusCode === 200) {
            yield put({ type: 'GET_DELETE_REQ_USERS_LIST_SUCCESS', userList: {...userListRes, ...action.data} });
        } else {
            if (userListRes.statusCode === 401) {
                logOut('error', userListRes.message)
            } else {
                createNotification('error', userListRes.message);
                yield put({ type: 'GET_DELETE_REQ_USERS_LIST_FAILURE', message: userListRes.message });
            }
        }
    } catch (e) {
        yield put({ type: 'GET_DELETE_REQ_USERS_LIST_FAILURE', message: "No data available to show for guests users" });
    }
}

const recoverAccountApi = async (data) => {
    
    try {
        const response = await instance.put(`${recoverAccount_API}/${data.id}`);
        return response;
    } catch (errors) {
        console.log("errors", errors)
        if (
            errors.response.data.statusCode === 400) {
            createNotification('error', errors.response.data.message);
            return
        } if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
}

function* recoverAccount(action) {
    try {
        const response = yield call(recoverAccountApi, action.data);
        const recoverAccountRes = response;

        if (recoverAccountRes.statusCode === 200) {
            yield put({ type: 'RECOVER_ACCOUNT_SUCCESS'});
            createNotification('success', recoverAccountRes.message);
            action.data.onSuccessCallback?.()
        } else {
            if (recoverAccountRes.statusCode === 401) {
                logOut('error', recoverAccountRes.message)
            } else {
                createNotification('error', recoverAccountRes.message);
            }
            yield put({ type: 'RECOVER_ACCOUNT_FALIURE'});
        }
    } catch (e) {
        yield put({ type: 'RECOVER_ACCOUNT_FALIURE', message: e.message });
    }
}

const deleteAccountPermanentlyApi = async (data) => {
    
    try {
        const response = await instance.delete(`${deleteAccountPermanently_API}/${data.id}`);
        return response;
    } catch (errors) {
        console.log("errors", errors)
        if (
            errors.response.data.statusCode === 400) {
            createNotification('error', errors.response.data.message);
            return
        } if (errors.response.data.statusCode === 401) {
            logOut('error', errors.response.data.message);
            createNotification('error', errors.response.data.message);
        } else {
            createNotification('warning', "Something went wrong");
        }
        return errors
    }
}

function* deleteAccountPermanently(action) {
    try {
        const response = yield call(deleteAccountPermanentlyApi, action.data);
        const deleteAccountPermanentlyRes = response;

        if (deleteAccountPermanentlyRes.statusCode === 200) {
            yield put({ type: 'DELETE_ACCOUNT_PERMENENTLY_SUCCESS'});
            createNotification('success', deleteAccountPermanentlyRes.message);
            action.data.onSuccessCallback?.()
        } else {
            if (deleteAccountPermanentlyRes.statusCode === 401) {
                logOut('error', deleteAccountPermanentlyRes.message)
            } else {
                createNotification('error', deleteAccountPermanentlyRes.message);
            }
            yield put({ type: 'DELETE_ACCOUNT_PERMENENTLY_FALIURE'});
        }
    } catch (e) {
        yield put({ type: 'DELETE_ACCOUNT_PERMENENTLY_FALIURE', message: e.message });
    }
}